import React, { useState } from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Input } from '@nextui-org/react';
import { FiX, FiSend } from 'react-icons/fi';
import { postProjectJoin } from '../../../services/projects';

const JoinProjectModal = ({ isOpen, onClose }) => {
  const [projectSlug, setProjectSlug] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleJoinProject = async () => {
    if (!projectSlug.trim()) {
      setError('Proje slug\'ı giriniz');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await postProjectJoin(projectSlug.trim());
      setSuccess(response.message || 'Katılım isteği başarıyla gönderildi!');
      setProjectSlug('');
      
      // 2 saniye sonra modal'ı kapat
      setTimeout(() => {
        onClose();
        setSuccess('');
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Katılım isteği gönderilirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setProjectSlug('');
    setError('');
    setSuccess('');
    onClose();
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={handleClose}
      size="md"
      hideCloseButton={true}
      classNames={{
        base: "bg-white dark:bg-dark-300",
        header: "border-b border-gray-200 dark:border-gray-600",
        body: "py-6",
        footer: "border-t border-gray-200 dark:border-gray-600"
      }}
    >
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          <div className="flex items-center justify-between w-full">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Projeye Katıl
            </h3>
            <Button
              isIconOnly
              variant="light"
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
            >
              <FiX size={20} />
            </Button>
          </div>
        </ModalHeader>
        
        <ModalBody>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Proje Uzantısı
              </label>
              <Input
                type="text"
                placeholder="proje-uzantisi - Örnek: proje-1234"
                value={projectSlug}
                onChange={(e) => setProjectSlug(e.target.value)}
                classNames={{
                  inputWrapper: "bg-white dark:bg-dark-300 border-gray-300 dark:border-gray-600",
                  input: "text-gray-900 dark:text-white",
                  placeholder: "text-gray-500 dark:text-gray-400"
                }}
                disabled={loading}
              />
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                Proje sahibinden aldığınız uzantıyı giriniz
              </p>
            </div>

            {/* Error Message */}
            {error && (
              <div className="p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
                <p className="text-red-800 dark:text-red-200 text-sm">{error}</p>
              </div>
            )}

            {/* Success Message */}
            {success && (
              <div className="p-3 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg">
                <p className="text-green-800 dark:text-green-200 text-sm">{success}</p>
              </div>
            )}
          </div>
        </ModalBody>
        
        <ModalFooter>
          <Button
            color="primary"
            onClick={handleJoinProject}
            isLoading={loading}
            disabled={!projectSlug.trim() || loading}
            className="bg-[#039be5] dark:bg-[#0889C9] text-white"
            startContent={!loading && <FiSend size={16} />}
          >
            {loading ? 'Gönderiliyor...' : 'Katılım İsteği Gönder'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default JoinProjectModal;
